import Btn from './btn';

function btn(props) {
  return new Btn(props);
}

export default btn;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/btn/index.js
// module id = 547
// module chunks = 9